import { useState } from 'react';
import Icon from './Icon';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!email.trim()) return;
    setDone(true);
    setEmail('');
  };

  return (
    <section className="section section--tight">
      <div className="container">
        <div className="newsletter">
          <div>
            <p className="kicker">Stay Informed</p>
            <h2>Security alerts, straight to your inbox</h2>
            <p>
              A short monthly briefing on active scams, patch reminders, and renewal deals. No spam,
              unsubscribe any time.
            </p>
          </div>

          <div>
            {done ? (
              <p className="newsletter__done">
                <Icon name="check" size={20} strokeWidth={2.6} />
                You are subscribed. Watch your inbox for the next briefing.
              </p>
            ) : (
              <form className="newsletter__form" onSubmit={handleSubmit}>
                <label htmlFor="newsletter-email" style={{ position: 'absolute', left: -9999 }}>
                  Email address
                </label>
                <input
                  id="newsletter-email"
                  className="newsletter__input"
                  type="email"
                  name="email"
                  required
                  autoComplete="email"
                  placeholder="you@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button type="submit" className="btn btn--red">
                  Subscribe
                </button>
              </form>
            )}
            <p className="newsletter__fine">
              We never share your address. See our Privacy Policy for details.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
